import { Injectable } from '@angular/core';
import {
  GetAllUsersResponse,
  GetUserDetailsResponse,
} from '@modules/company-manager/users/domain';
import {
  GetAllRequestResponse,
  GetSingleRequestResponse,
} from '@modules/regular-user/requests/domain/entities/requests.entity';
import { ApiQueryParams } from '@utils/api-query-params.type';
import { Observable } from 'rxjs';
import {
  Approve,
  GetApprovalsCountResponse,
  GetApprovesResponse,
} from '../entities/approves.entity';

@Injectable()
export abstract class ApprovesServices {
  /**
   * All Approves
   */
  abstract getAllApproves(companyId: string): Observable<GetApprovesResponse>;

  /**
   * Export Approve
   */
  abstract exportApproves(approves: Approve[]): Observable<any>;

  /**
   * Approve By Id
   */
  abstract getApproveById(
    approveId: string
  ): Observable<GetSingleRequestResponse>;

  /**
   * Get My Approves
   */
  abstract myApproves(query: ApiQueryParams): Observable<GetAllRequestResponse>;

  /**
   * Approve A Request
   */
  abstract approveARequest(
    requestId: string,
    message: string
  ): Observable<GetSingleRequestResponse>;

  /**
   * Deny A Request
   */
  abstract denyARequest(
    requestId: string,
    message: string
  ): Observable<GetSingleRequestResponse>;

  /**
   * Get Requests Count
   */
  abstract approvalsCount(
    query: ApiQueryParams
  ): Observable<GetApprovalsCountResponse>;

  /**
   *
   */
  abstract pendingApprovals(
    query: ApiQueryParams
  ): Observable<GetApprovesResponse>;

  /**
   *
   */
  abstract getApproversByCompany(
    companyId: string
  ): Observable<GetApprovesResponse>;
}
